import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import { Icon } from '@aloft/toolkit-sui';

import { LoadingScreenSam } from '../../../components/LoadingScreen/LoadingScreenSam.tsx';
import { Flex } from '../../../summary/components/Flex.tsx';
import { AbsorptionRate } from './graphs/AbsorptionRate.tsx';
import { MedianSalePriceToListPrice } from './graphs/MediaSalePricetoListPrice.tsx';
import { MedianDOM } from './graphs/MedianDOM.tsx';
import { MedianListPrice } from './graphs/MedianListPrice.tsx';
import { MedianSalePrice } from './graphs/MedianSalePrice.tsx';
import { MonthsOfHousingSupply } from './graphs/MonthsOfHousingSupply.tsx';
import { TotalComparableListings } from './graphs/TotalComparableListings.tsx';
import { TotalComparableSales } from './graphs/TotalComparableSales.tsx';

export const MarketConditionsGraphs = ({
  marketAggregateData,
  isLoading,
  isError,
}: {
  marketAggregateData: AbodeAggregateMarketConditions;
  isLoading: boolean;
  isError: boolean;
}) => {
  if (isLoading) {
    return <LoadingScreenSam overrideText="Loading market conditions..." />;
  }
  if (isError || !marketAggregateData || marketAggregateData.monthlyData.length === 0) {
    return (
      <Flex alignItems="center" gap={2}>
        <Icon icon="error-warning" color="error" /> Error loading market condition analysis data.
        Please try another filter or ZIP code
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" gap={6} marginBottom={6}>
      <TotalComparableSales data={marketAggregateData} />
      <AbsorptionRate data={marketAggregateData} />
      <TotalComparableListings data={marketAggregateData} />
      <MonthsOfHousingSupply data={marketAggregateData} />
      <MedianSalePrice data={marketAggregateData} />
      <MedianListPrice data={marketAggregateData} />
      <MedianSalePriceToListPrice data={marketAggregateData} />
      <MedianDOM data={marketAggregateData} />
    </Flex>
  );
};
